'use strict';

import angular from 'angular';
import moment from 'moment';
import 'moment-pl';

/**
 * @ngdoc overview
 * @name commonModule.commonFilters
 * @description
 * # commonModule.commonFilters
 * Module for managing the common filters.
 */
const commonFilters = angular.module('commonModule.commonFilters', []);

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:makeRange
 * @description
 * Filter for creating range (for pagination purposes)
 * http://stackoverflow.com/a/14932395/3102996
 */
commonFilters.filter('makeRange', () => {
    return (input) => {
        let lowBound, highBound;
        switch (input.length) {
            case 1:
                lowBound = 0;
                highBound = parseInt(input[0], 10) - 1;
                break;
            case 2:
                lowBound = parseInt(input[0], 10);
                highBound = parseInt(input[1], 10);
                break;
            default:
                return input;
        }
        const result = [];
        for (let i = lowBound; i <= highBound; i++) {
            result.push(i);
        }

        return result;
    };
});

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:reverse
 * @description
 * Filter for reversing the order (for ng-repeat)
 */
commonFilters.filter('reverse', () => {
    return (items) => {
        if (items) {
            return items.slice().reverse();
        } else {
            return items;
        }
    };
});

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:propsFilter
 * @description
 * Filter for ui-select
 */
commonFilters.filter('propsFilter', () => {
    return (items, props) => {
        const out = [];

        if (angular.isArray(items)) {
            angular.forEach(items, (item) => {
                let itemMatches = false;

                const keys = Object.keys(props);
                for (let i = 0; i < keys.length; i++) {
                    const prop = keys[i];
                    const text = props[prop].toLowerCase();
                    if (item[prop].toString().toLowerCase().indexOf(text) !== -1) {
                        itemMatches = true;
                        break;
                    }
                }

                if (itemMatches) {
                    out.push(item);
                }
            });
        } else {
            // Let the output be the input untouched
            return items;
        }

        return out;
    };
});

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:moment
 * @description
 * Filter for moment.js date format
 */
commonFilters.filter('moment', () => {
    return (dateString, format) => {
        return moment(dateString).format(format);
    };
});

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:shortDate
 * @description
 * Filter for short date format (only date) - moment.js format
 */
commonFilters.filter('shortDate', ['DATE_FORMAT', function (DATE_FORMAT) {
    return (dateString) => {
        if (angular.isNullOrUndefined(dateString)) {
            return '-';
        } else {
            return moment(dateString).format(DATE_FORMAT.SHORT);
        }
    };
}]);

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:fullDate
 * @description
 * Filter for full date format (date & time) - moment.js format
 */
commonFilters.filter('fullDate', ['DATE_FORMAT', function (DATE_FORMAT) {
    return (dateString) => {
        if (angular.isNullOrUndefined(dateString)) {
            return '-';
        } else {
            return moment(dateString).format(DATE_FORMAT.FULL);
        }
    };
}]);

/**
 * @ngdoc filter
 * @name commonModule.commonFilters.filter:filterSelected
 * @description
 * Filter out selected beacons from typeahead
 */
commonFilters.filter('filterSelected', ['$filter', function ($filter) {
    return (items, selected) => {
        const uniqueItems = [];
        const allItems = [];

        angular.forEach(items, (item) => {
            allItems[item.beacon.id] = item;
        });

        angular.forEach(selected, (item) => {
            const index = item.beacon.id;
            if (angular.isDefined(allItems[index])) {
                delete allItems[index];
            }
        });

        angular.forEach(allItems, (item) => {
            uniqueItems.push(item);
        });

        return $filter('orderBy')(uniqueItems, 'beacon.name');
    };
}]);

commonFilters.filter('changeSpecial', () => {
    return (items) => {
        const dict = {'ą': 'a', 'ę': 'e', 'ć': 'c', 'ł': 'l', 'ń': 'n', 'ó': 'o', 'ś': 's', 'ż': 'z', 'ź': 'z'};
        let str = angular.copy(items);
        str = str.replace(/\s+/g, ' ');
        str = str.replace(/[^\w ]/g, (char) => {
            return dict[char] || char;
        });
        str = str.toLowerCase().trim();
        str = str.replace(/\s/g, '_');

        return str;
    };
});

commonFilters.filter('removeSpecial', () => {
    return (items) => {
        let str = angular.copy(items);
        str = str.replace(/\s+/g, ' ');
        str = str.replace(/[/\\#,+()[\]$~'":*?<>{}@^`]+/g, '');
        str = str.toLowerCase().trim();

        if (str.length > 0) {
            return str;
        }
    };
});

commonFilters.filter('removeSpaces', () => {
    return (string) => {
        if (!angular.isString(string)) {
            return string;
        }

        return string.replace(/[\s]/g, '');
    };
});

commonFilters.filter('removeSpecialWithoutSlash', () => {
    return (items) => {
        let str = angular.copy(items);
        str = str.replace(/\s+/g, ' ');
        str = str.replace(/[\\#,+()[\]$~'":*?<>{}@^`]+/g, '');
        str = str.toLowerCase().trim();

        if (str.length > 0) {
            return str;
        }
    };
});

export default commonFilters;